import { render, staticRenderFns } from "./MPCheckoutApi.vue?vue&type=template&id=166c4da8&scoped=true"
import script from "./MPCheckoutApi.vue?vue&type=script&lang=js"
export * from "./MPCheckoutApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c4da8",
  null
  
)

export default component.exports